const ExpandCollapse = {
    init() : void {
        const $expandCollapseElements = document.querySelectorAll<HTMLElement>('.js-expand-collapse');

        $expandCollapseElements.forEach($expandCollapseElement => {
            this.initExpandCollapse($expandCollapseElement);
        });
    },

    initExpandCollapse($element: HTMLElement) : void {
        const $cta = $element.querySelector<HTMLElement>('.js-expand-collapse-cta');

        $cta?.addEventListener('click', () => {
            $element.classList.toggle('open');
        });
    },

};

export default ExpandCollapse;
